<template>
	<v-footer color="primary" dark>
		<v-container>
			<v-row align="center" justify="space-between">
				<v-col cols="12" sm="4" class="d-flex flex-column justify-content-center align-items-center align-items-sm-start align-items-md-start align-items-lg-start align-items-xl-start pl-0">
					<v-img
						:src="logo"
						alt="Cyber Integrity Initiative"
						max-width="270"
						contain
					>
						<template v-slot:placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular
									indeterminate
									color="grey lighten-5"
								></v-progress-circular>
							</v-row>
						</template>
					</v-img>
					<div class="text-body-2 text-description mt-2">
						INNOVATION. CYBERSECURITY. COMPLIANCE.
					</div>
				</v-col>
				<v-col sm="4">
				</v-col>
				<v-col
					cols="12"
					sm="4"
					class="text-follow-us text-center d-flex justify-content-center align-items-center flex-column flex-md-row"
				>
				<v-row style="min-width:300px" class="p-2 justify-content-center">	
					<v-col cols="7" class="d-flex align-items-center justify-content-end pl-0 pr-1">FOLLOW US ON</v-col>
					<v-col cols="5" class="d-flex justify-content-start align-items-center pl-1">
						<v-btn
							v-for="icon in socialIcons"
							:key="icon.id"
							icon
							:href="icon.link"
							target="_blank"
						>
							<img
								:src="icon.svg"
								style="object-fit: contain; max-width: 30px;"
								:alt="icon.altText"
							/>
						</v-btn>
					</v-col>
				</v-row>
				</v-col>
			</v-row>
			<v-divider class="my-4"></v-divider>
			<v-row align="center" justify="space-between">
				
				<v-col cols="12" sm="6" class="text-center ">
					<v-btn
						text
						small
						@click="$bvModal.show('modal-privacy')"
						class="mr-2 text-underline-links"
						>PRIVACY POLICY</v-btn
					>
					<v-btn
						text
						small
						@click="showFooterOverlay = true"
						class="text-underline-links"
						>DISCLAIMER</v-btn
					>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					class="text-question justify-content-center text-left d-flex align-items-center mb-3 mb-lg-0 mb-xl-0"
				>
					<div>ANY QUESTIONS? ASK HERE ></div>
				</v-col>
			</v-row>
			<v-row justify="center" align="center">
				<v-col cols="12" class="text-center d-flex align-items-center justify-content-center p-0">
					<div class="text-copyright d-flex align-items-center">
						© {{ currentYear }} Copyright. Project Spectrum. All Rights Reserved.
					</div>
				</v-col>
			</v-row>
			<!-- Disclaimer Modal -->
			<div v-show="showFooterOverlay" class="modal-window-overlay">
				<div class="modal-window-display">
					<div class="disclaimer-navbar">
						<!-- DISCLAIMER NAVBAR -->
						<div class="container-fluid disclaimer-navbar-content">
							<v-row class="disclaimer-navbar-row">
								<v-col :cols="isMobileView ? 10 : 11" class="m-0 p-0 h-100">
									<div class="container-fluid h-100 d-flex justify-content-center align-items-center">
										<!-- DESKTOP DISCLAIMER NAVBAR ROW -->
										<!-- DESKTOP DISCLAIMER NAVBAR ROW -->
										<v-row class="h-100 d-none d-lg-flex d-xl-flex">
											<v-col 
												cols="2.4" 
												class="p-0 d-flex justify-content-center align-items-center" 
												:style="{ color: selectedDisclaimerNavItem === 'General' ? '#FFCD00' : '#FFFFFF' }"
												@click="selectedDisclaimerNavItem = 'General'"
											>
												<span class="disclaimer-navbar-text">General</span>
											</v-col>
											<v-col 
												cols="2.4" 
												class="p-0 d-flex justify-content-center align-items-center" 
												:style="{ color: selectedDisclaimerNavItem === 'Training Content' ? '#FFCD00' : '#FFFFFF' }"
												@click="selectedDisclaimerNavItem = 'Training Content'"
											>
												<span class="disclaimer-navbar-text">Training Content</span>
											</v-col>
											<v-col 
												cols="2.4" 
												class="p-0 d-flex justify-content-center align-items-center" 
												:style="{ color: selectedDisclaimerNavItem === 'Cyber Adviser' ? '#FFCD00' : '#FFFFFF' }"
												@click="selectedDisclaimerNavItem = 'Cyber Adviser'"
											>
												<span class="disclaimer-navbar-text">Cyber Adviser</span>
											</v-col>
											<v-col 
												cols="2.4" 
												class="p-0 d-flex justify-content-center align-items-center" 
												:style="{ color: selectedDisclaimerNavItem === 'Useful Tools' ? '#FFCD00' : '#FFFFFF' }"
												@click="selectedDisclaimerNavItem = 'Useful Tools'"
											>
												<span class="disclaimer-navbar-text">Useful Tools</span>
											</v-col>
											<v-col 
												cols="2.4" 
												class="p-0 d-flex justify-content-center align-items-center" 
												:style="{ color: selectedDisclaimerNavItem === 'LLA' ? '#FFCD00' : '#FFFFFF' }"
												@click="selectedDisclaimerNavItem = 'LLA'"
											>
												<span class="disclaimer-navbar-text">LLA</span>
											</v-col>
										</v-row>

										<!-- MOBILE DISCLAIMER NAVBAR ROW -->
										<v-row class="m-0 h-100 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none">
											<v-col cols="2" class="h-100 m-0 p-0 d-flex justify-column-start align-items-center">
												<button
													v-b-toggle.sidebar-backdrop
													class="navbar-toggler ml-2 p-0"
													type="button"
													@click="showDisclaimerNavigationMenu"
												>
													<i :class="{
														'mdi mdi-menu': !isDisclaimerMobileMenuOpened,
														'mdi mdi-close': isDisclaimerMobileMenuOpened,
													}"></i>
												</button>
											</v-col>
											<v-col cols="10" class="project-spectrum-image">
												<img
													src="../assets/images/logo/PSLogo-Desktop.png"
													alt=""
												/>
											</v-col>
										</v-row>
									</div>
								</v-col>
								<v-col :cols="isMobileView ? 2 : 1" class="p-0 d-flex justify-content-center align-items-center">
									<div class="modal-window-close-container">
										<button 
											type="button" 
											class="modal-window-close-container-button"
											@click="showFooterOverlay = false"
										>
											<i class="mdi mdi-close">
											</i>
										</button>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
					<!-- DISCLAIMER BODY CONTENT -->
					<div class="modal-window-body">
						<div class="container-fluid p-0">
							<v-row 
								v-if="(!isDisclaimerMobileMenuOpened && !hasDisclaimerButtons) || !isMobileView"
								class="disclamer-body-content"
							>
								<v-col lg="4" xl="4" class="h-100 d-none d-lg-flex d-xl-flex" style="padding-right: 0; padding-left: 30px;">
									<div class="w-100 h-100 d-flex flex-column">
										<div class="disclaimer-title-section">
											<span class="modal-window-title-text">{{ disclaimerTitleText }}</span>
										</div>
										<div class="disclaimer-button-section">
											<v-btn
												v-for="button in disclaimerTitleButtons"
												:key="button.title"
												class="mb-5"
												outlined
												rounded
												width="280"
												:color="navControlTitleSelection[selectedDisclaimerNavItem].selectedTextContent === button.title ? primaryYellowColor : primaryWhiteColor"
												@click="setActiveDisclaimerButtonText(button.title)"
											>
												{{ button.title }}
											</v-btn>
										</div>
									</div>
								</v-col>
								<v-col cols="12" class="m-0 p-0 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none">
									<div class="w-100 pl-4 pt-3 d-flex flex-row justify-content-start align-items-center">
										<span 
											style="font-size: 28px;" 
											class="modal-window-title-text"
										>
											{{ disclaimerTitleText }}
										</span>
									</div>
								</v-col>
								<v-col 
									cols="12" 
									lg="8" 
									xl="8" 
									class="h-100 d-flex justify-content-center" 
									:class="{
										'align-items-center': !isMobileView,
										'align-items-start': isMobileView,
									}"
								>
									<div 
										:style="{ height: isMobileView ? '92%' : '97%' }"
										class="modal-window-text-content" 
										v-html="disclaimerText"
									>
									</div>
								</v-col>
							</v-row>

							<v-row 
								v-if="(isDisclaimerMobileMenuOpened || hasDisclaimerButtons) && isMobileView"
								style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;"
								:style="{ backgroundColor: hasDisclaimerButtons ? 'transparent' : '#424EC4' }"
								class="m-0 p-0 h-100 d-none d-sm-flex d-md-none d-flex d-sm-none d-md-flex d-lg-none d-xl-none"
							>
								<v-col v-if="!hasDisclaimerButtons" cols="12" class="d-flex flex-column justify-column-start">
									<div 
										style="height: 70px;" 
										:style="{ color: selectedDisclaimerNavItem === 'General' ? '#FFCD00' : '#FFFFFF' }"
										class="w-100 d-flex flex-row justify-content-center align-items-center"
										@click="() => disclaimerNavigationClickHandler('General')"
									>
										<span class="disclaimer-navbar-text">General</span>
									</div>
									<div 
										style="height: 70px;" 
										:style="{ color: selectedDisclaimerNavItem === 'Training Content' ? '#FFCD00' : '#FFFFFF' }"
										class="w-100 d-flex flex-row justify-content-center align-items-center"
										@click="() => disclaimerNavigationClickHandler('Training Content')"
									>
										<span class="disclaimer-navbar-text">Training Content</span>
									</div>
									<div 
										style="height: 70px;" 
										:style="{ color: selectedDisclaimerNavItem === 'Cyber Adviser' ? '#FFCD00' : '#FFFFFF' }"
										class="w-100 d-flex flex-row justify-content-center align-items-center"
										@click="() => disclaimerNavigationClickHandler('Cyber Adviser')"
									>
										<span class="disclaimer-navbar-text">Cyber Adviser</span>
									</div>
									<div 
										style="height: 70px;" 
										:style="{ color: selectedDisclaimerNavItem === 'Useful Tools' ? '#FFCD00' : '#FFFFFF' }"
										class="w-100 d-flex flex-row justify-content-center align-items-center"
										@click="() => disclaimerNavigationClickHandler('Useful Tools')"
									>
										<span class="disclaimer-navbar-text">Useful Tools</span>
									</div>
									<div 
										style="height: 70px;" 
										:style="{ color: selectedDisclaimerNavItem === 'LLA' ? '#FFCD00' : '#FFFFFF' }"
										class="w-100 d-flex flex-row justify-content-center align-items-center"
										@click="() => disclaimerNavigationClickHandler('LLA')"
									>
										<span class="disclaimer-navbar-text">LLA</span>
									</div>
								</v-col>

								<v-col v-else-if="hasDisclaimerButtons" cols="12" class="d-flex flex-column justify-column-start">
									<div class="disclaimer-button-section pt-5">
										<v-btn
											v-for="button in disclaimerTitleButtons"
											:key="button.title"
											class="mb-5"
											outlined
											rounded
											width="280"
											:color="navControlTitleSelection[selectedDisclaimerNavItem].selectedTextContent === button.title ? '#FFCD00' : '#ffffff'"
											@click="setActiveDisclaimerButtonText(button.title)"
										>
											{{ button.title }}
										</v-btn>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</div>
			<!-- <b-modal id="modal-disclaimer" title="Disclaimer" size="xl">
				<div v-html="disclaimerContent"></div>
				<template #modal-footer>
					<b-button
						size="sm"
						variant="dark"
						@click="$bvModal.hide('modal-disclaimer')"
					>
						Close
					</b-button>
				</template>
			</b-modal> -->

			<!-- Privacy Modal -->
			<b-modal id="modal-privacy" title="Privacy Policy" size="xl">
				<div v-html="privacyContent"></div>
				<template #modal-footer>
					<b-button
						size="sm"
						variant="dark"
						@click="$bvModal.hide('modal-privacy')"
					>
						Close
					</b-button>
				</template>
			</b-modal>
			<!-- Back To Top -->
			<a href="#" class="back_top"> <i class="mdi mdi-chevron-up"></i></a>
		</v-container>
	</v-footer>
</template>

<script>
const DISCLAIMER_SUBJECTS = {
	GENERAL: "General",
	TRAINING_CONTENT: "Training Content",
	CYBER_ADVISOR: "Cyber Adviser",
	USEFUL_TOOLS: "Useful Tools",
	LIMITED_LIABILITY_AGREEMENT: "LLA"
};

export default {
	data() {
		return {
			disclaimerSubjects: DISCLAIMER_SUBJECTS,
			showFooterOverlay: false,
			isDisclaimerMobileMenuOpened: false,
			hasDisclaimerButtons: false,
			selectedDisclaimerNavItem: DISCLAIMER_SUBJECTS.GENERAL,
			navControlTitleSelection: {
				[DISCLAIMER_SUBJECTS.GENERAL]: {
					title: 'General Disclaimers',
					buttons: [],
					text: `
					<p>This website is offered to you, the user ("User", "you", "your"), conditioned on acceptance of the terms, conditions and notices contained herein, without modification.  User access and use of this site constitutes acceptance of these terms and conditions. Please read this disclaimer ("disclaimer") carefully before using the Project Spectrum website ("website", "service") operated by Eccalon ("Resource Provider", "us", "we", "our"). By accessing or using our website, you agree to the terms outlined in this disclaimer.</p>
					<b>Introduction</b>
					<br><br>
					<p>Project Spectrum is a learning platform that provides educational content, including courses, training videos, and resources. The information provided on this platform is for general informational purposes only, and while we strive for accuracy and quality, we cannot guarantee the completeness, reliability, or suitability of the information provided. Resource Provider is not responsible for any errors, omissions, or the results obtained from the use of the information in its courses or other training content. Users should verify any information before relying on it.</p>
					<b>Third-Party Links</b>
					<br><br>
					<p>Our platform may contain links to third-party websites or resources. These links are provided for convenience, and we do not endorse or control the content on external sites. Users should review the terms and privacy policies of linked websites. Resource Provider has no responsibility or liability for any information, communications or materials available at such linked sites, or at any link contained in a linked site. The User assumes sole responsibility for the use and any consequences of using third-party websites.</p>
					<b>Access and Use of the Service</b>
					<br><br>
					<p>The Project Spectrum website, and any content viewed through our site, is only for your personal and non-commercial use. Any other use requires explicit permission from Resource Provider.</p>
					<b>Training Content and Trademarks</b>
					<br><br>
					<p>All training content on this website, including text, images, videos, and other materials, is protected by copyright law. The training content is designed by us and is the intellectual property of Resource Provider and/or its creators. You acknowledge and agree that the Project Spectrum site may contain other content or features that are protected by copyright, patent, trademark or other intellectual property rights and laws. Unless otherwise authorized by Resource Provider, you agree to not change, copy, sell, distribute, or create derivative works based on, the Project Spectrum site or the course content.</p>
					<b>Indemnification</b>
					<br><br>
					<p>You agree to indemnify, defend, and hold harmless Resource Provider and its affiliates, directors, employees, Cyber Advisers, and related parties from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your participation in our course(s).</p>
					<b>No Representations or Warranties</b>
					<br><br>
					<p>Resource Provider makes no representations or warranties of any kind, express or implied, regarding the results that may be obtained from participating in Project Spectrum. The course content is provided "as is" and "as available" without any warranties of any kind.</p>
					<b>Limitation of Liability</b>
					<br><br>
					<p>To the fullest extent permitted by law, Resource Provider its affiliates, members, directors, employees, Cyber Advisers, and related parties shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or damages of any other kind or nature, arising out of or related to your participation in Project Spectrum courses, whether based in contract, tort, strict liability, or otherwise, even if Resource Provider has been advised of the possibility of such damages.</p>
					<b>Changes to Disclaimer</b>
					<br><br>
					<p>We reserve the right to modify or update this disclaimer at any time. Users should check this page periodically for changes.</p>
					`
				},
				[DISCLAIMER_SUBJECTS.TRAINING_CONTENT]: {
					title: 'Training Content Disclaimers',
					selectedTextContent: 'Training',
					buttons: [
						{
							title: 'Training',
							text: `
							<p>This website is offered to you, the user ("User",  "you", "your"), conditioned on acceptance of the terms, conditions and notices contained herein, without modification.  User access and use of this site constitutes acceptance of these terms and conditions. Please read this disclaimer ("disclaimer") carefully before using the Project Spectrum website (“website”, "service") operated by Eccalon ("Resource Provider", "us", 'we", "our"). By accessing or using our website, you agree to the terms outlined in this Training Content Disclaimer.</p>
							<b>Training Content</b>
							<br><br>
							<p>The information provided on the Project Spectrum website is for general informational purposes only. While we make every effort to keep the content accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or availability with respect to the website. We also make no representations or warranties regarding the information, products, services, or related graphics contained on the Project Spectrum website for any purpose. Any reliance you place on such information is strictly at your own risk.</p>
							<b>Usage of Training Materials</b>
							<br><br>
							<p>The training materials provided by Project Spectrum are intended for educational purposes only. We are not responsible for how the training is used or applied in real-world scenarios. Users are advised to use their own judgment when applying any training techniques or strategies derived from the Project Spectrum courses. We are not liable for any errors or omissions in the content.</p>
							<b>Content Updates</b>
							<br><br>
							<p>We do not guarantee that the content on this website will always be up-to-date. The fields of training and technology are constantly evolving. Although we make efforts to update our materials for changes in our industry, we cannot ensure that all information will be current at the time you visit the Project Spectrum site.</p>
							<b>Course Offerings</b>
							<br><br>
							<p>The courses and training programs offered by Project Spectrum are subject to change without prior notice. We reserve the right to remove, edit or add new content at our discretion. We are not responsible for any inconvenience or loss that may result from changes to our course offerings. Course offerings are also subject to the Liability Waiver sections below. By using this website, you agree to these terms and conditions. If you do not agree with any part of this disclaimer, please do not use our website.</p>
							`,
						},
						{
							title: 'Liability',
							text: `
							<b>Liability Waiver</b>
							<br><br>
							<span>1. Acknowledgment of Risk</span>
							<br><br>
							<p>By enrolling in and participating in Project Spectrum, you acknowledge and agree that the course(s) are provided for educational purposes only. You understand that the application of the information and techniques taught in the course(s) is at your own risk.</p>
							<span>2. No Representations or Warranties</span>
							<br><br>
							<p>Resource Provider makes no representations or warranties of any kind, express or implied, regarding the results that may be obtained from participating in Project Spectrum. The course content is provided "as is" and "as available" without any warranties of any kind.</p>
							<span>3. No Certification Guarantee</span>
							<br><br>
							<p>Resource Provider does not grant academic credit for the completion of courses, nor do we guarantee participating in Project Spectrum will grant users CMMC certifications. Participation in or completion of course offerings is for your own educational purposes only. There is no presumption that other institutions will accept completion of our courses as certification. Resource Provider, Cyber Advisers, and the associated content providers have no obligation to have course offerings recognized by any educational institution or accreditation organization.</p>
							<span>4. Limitation of Liability</span>
							<br><br>
							<p>To the fullest extent permitted by law, Resource Provider, its affiliates, members, directors, employees, Cyber Advisers, and related parties shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or damages of any other kind or nature, due to or related to your participation in Project Spectrum courses, whether based in contract, tort, strict liability, or otherwise, even if Resource Provider has been advised of the possibility of such damages.</p>
							<span>5. Indemnification</span>
							<br><br>
							<p>You agree to indemnify, defend, and hold harmless Resource Provider and its affiliates, directors, employees, Cyber Advisers, and related parties from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that you may incur as a result of or occurring from your participation in our course(s).</p>
							<span>6. No Professional Advice</span>
							<br><br>
							<p>The course content is not intended to be a substitute for professional advice. Always seek the advice of your lawyer or other qualified professional with any questions you may have regarding legal or other professional matters.</p>
							<span>7. Governing Law</span>
							<br><br>
							<p>This Liability Waiver shall be governed, construed, and enforced in accordance with the laws of the state of Maryland, without regard to its choice of law provisions.</p>
							<span>8. Acceptance of Terms</span>
							<br><br>
							<p>By enrolling in and participating in courses on the Project Spectrum website, you acknowledge that you have read, understood, and agree to be bound by the terms of this Liability Waiver.</p>
							`,
						}
					],
				},
				[DISCLAIMER_SUBJECTS.CYBER_ADVISOR]: {
					title: 'Cyber Adviser Disclaimers',
					buttons: [],
					text: `
					<p>This website is offered to you, the user ("User," "you," "your"), conditioned on acceptance of the terms, conditions, and notices contained herein, without modification. User access and use of this site constitutes acceptance of these terms and conditions. Please read this disclaimer ("Disclaimer") carefully before using the Project Spectrum website (“website,” "service") operated by Eccalon (“Resource Provider," "us," "we," "our"). By accessing or using our website, you agree to the terms outlined in this Cyber Adviser Disclaimer. </p>
					<b>Advice Only</b>
					<br><br>
					<p>By using the Project Spectrum site, you understand that you are participating in cybersecurity courses offered by Project Spectrum and may receive advice from Cyber Advisers. The courses and any advice provided may be used at your own discretion. Advice given by Cyber Advisers is for guidance purposes only.</p>
					<p>You acknowledge that any advice received from Cyber Advisers is used at your own risk. Cyber Advisers are not responsible for the consequences of following their advice, including financial loss, costs, or other damages. You should consult with a qualified professional before implementing any advice received from a Cyber Adviser.</p>
					<p>By continuing to use the site, you acknowledge that you have read this Disclaimer and understand its contents. You voluntarily and knowingly agree to the terms and conditions stated herein. You are aware that by agreeing to these terms, you are waiving certain rights, including the right to pursue legal action against any Cyber Adviser. You agree to indemnify, defend, and hold harmless the Cyber Adviser(s) from any and all claims, liabilities, expenses, and damages arising out of or related to any advice provided to you.</p>
					<p>To the fullest extent permitted by applicable law, our Cyber Advisers and Resource Provider shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or damages of any other kind, arising from your participation in the courses—whether based in contract, tort, strict liability, or otherwise—even if the Cyber Adviser(s) has been advised of the possibility of such damages.</p>
					<span>1. No Representations or Warranties</span>
					<br><br>
					<p>The Cyber Adviser makes no guarantees, representations, or warranties of any kind, express or implied, regarding the results that may be obtained from participating in the courses. Course content is provided "as is" and "as available" without any warranties of any kind.</p>
					<span>2. Student-Cyber Adviser Relationship</span>
					<br><br>
					<p>Nothing in these terms and conditions, or your participation in Project Spectrum courses, creates a joint venture, partnership, employer-employee, or principal-agent relationship between you and any Cyber Adviser.<br><br>Additionally:</p>
					<ul>
						<li><p class="mb-0">This agreement does not enroll or register you in any other Project Spectrum course(s).</p></li>
						<li><p class="mb-0">You are not entitled to additional use of a Cyber Adviser's resources outside of the course content.</p></li>
					</ul>
					<span>3. Use of Course Materials</span>
					<br><br>
					<p>You acknowledge and agree that the use of any advice or additional course materials provided by the Cyber Adviser is at your own risk. The Cyber Adviser is not responsible for any errors or omissions in the course materials or for any loss or damage resulting from their use.</p>
					<span>4. Professional Advice</span>
					<br><br>
					<p>Course content is not intended to substitute professional advice. Always seek the guidance of a qualified professional for specific concerns or decisions.</p>
					<span>5. Indemnification</span>
					<br><br>
					<p>You agree to indemnify, defend, and hold harmless the Cyber Adviser from and against any and all claims, liabilities, damages, losses, costs, expenses, or legal fees (including reasonable attorneys' fees) that may result from your participation in the courses.</p>
					<span>6. Governing Law</span>
					<br><br>
					<p>This Disclaimer and any disputes arising under it shall be governed and enforced under the laws of the State of Maryland, without regard to its conflict of laws principles.</p>
					<p><strong>By enrolling in and participating in the course, you acknowledge that you have read, understood, and agreed to be bound by the terms of this Disclaimer.</strong></p>
					`,
				},
				[DISCLAIMER_SUBJECTS.USEFUL_TOOLS]: {
					title: 'Useful Tools Disclaimers',
					buttons: [],
					text: `
					<p>This website is offered to you, the user ("User", "you", "your"), conditioned on acceptance of the terms, conditions and notices contained herein, without modification.  User access and use of this site constitutes acceptance of these terms and conditions. Please read this disclaimer ("disclaimer") carefully before using the Project Spectrum website (“website”, "service") operated by Eccalon (“Resource Provider”, "us", 'we", "our"). By accessing or using our website, you agree to the terms outlined in this disclaimer. </p>
					<span>1. Third-Party Websites</span>
					<br><br>
					<p>Our website may contain links to third-party websites that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites. By using our website, you expressly relieve Resource Provider from any and all liability arising from your use of any link(s) to third-party website(s).</p>
					<span>2. Third-Party Software</span>
					<br><br>
					<p>Our website may recommend or provide access to third-party software. These recommendations are provided for your convenience and do not constitute an endorsement or approval by us of any third-party software. We are not responsible for any issues, damages, or losses that may occur due to your use of third-party software. You use such software at your own risk and discretion.</p>
					<span>3. Third-Party Content</span>
					<br><br>
					<p>Our website may include content provided by third parties, including but not limited to articles, reviews, and advertisements. Resource Provider does not guarantee the accuracy, completeness, or usefulness of any third-party content, nor do we endorse any opinions expressed by third parties. Any reliance you place on such content is strictly at your own risk.</p>
					<span>4. Third-Party Vendors</span>
					<br><br>
					<p>Resource Provider does not endorse any third-party tools or vendors. No vendor should take completing Project Spectrum courses as an endorsement of their product or service from Resource Provider. Additionally, Resource Provider is not responsible for any vendor information or vendor product or services. Resource Provider is in no joint venture, partnership, employment, contractor, or agency relationship with any vendor mentioned on this site. Vendors are not permitted to use the Project Spectrum logo or reference Project Spectrum in any advertisements for their products or services or to build a customer base. We do not endorse, approve, or certify any products, services, or companies on whose websites appear the name, logo or trademark of Project Spectrum. The inclusion of any references to Project Spectrum should not be interpreted as an endorsement.</p>
					<span>5. Recommendations</span>
					<br><br>
					<p>Any mention of third-party websites, software, or content on our website is for informational purposes only and does not constitute a recommendation or endorsement by Resource Provider. We are not responsible for any consequences that may occur from your use of third-party websites, software, or content.</p>
					<span>6. Limitation of Liability</span>
					<br><br>
					<p>Resource Provider cannot guarantee that such third-party content, in the Useful Tools page or elsewhere, will be free of defects or errors, material you may find objectionable, or of malware or other contaminants that may harm your computer, mobile device, or any files therein. Resource Provider disclaims any responsibility or liability related to your access or use of, or inability to access or use, such third-party content.</p>
					<p>To the fullest extent permitted by law, Resource Provider shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or any other damages of any kind or nature arising out of or related to your use of third-party websites, software, or content.</p>
					<p>By using our website, you acknowledge that you have read, understood, and agree to be bound by the terms of this Useful Tools Disclaimer.</p>
					`,
				},
				[DISCLAIMER_SUBJECTS.LIMITED_LIABILITY_AGREEMENT]: {
					title: 'Limited Liability Agreement',
					buttons: [],
					text: `
						<div class="disclaimer-content">
							<p>This website is offered to you, the user ("User", "you", "your"), conditioned on acceptance of the terms, conditions and notices contained herein, without modification. User access and use of this site constitutes acceptance of these terms and conditions. Please read this disclaimer ("disclaimer") carefully before using the Project Spectrum website ("website", "service") operated by Eccalon ("Resource Provider", "us", "we", "our"). By accessing or using our website, you agree to the terms outlined in this disclaimer.</p>

							<b>Introduction</b>
							<p>Project Spectrum is a learning platform that provides educational content, including courses, training videos, and resources. The information provided on this platform is for general informational purposes only, and while we strive for accuracy and quality, we cannot guarantee the completeness, reliability, or suitability of the information provided. Resource Provider is not responsible for any errors, omissions, or the results obtained from the use of the information in its courses or other training content. Users should verify any information before relying on it.</p>

							<b>Third-Party Links</b>
							<p>Our platform may contain links to third-party websites or resources. These links are provided for convenience, and we do not endorse or control the content on external sites. Users should review the terms and privacy policies of linked websites. Resource Provider has no responsibility or liability for any information, communications or materials available at such linked sites, or at any link contained in a linked site. The User assumes sole responsibility for the use and any consequences of using third-party websites.</p>

							<b>Access and Use of the Service</b>
							<p>The Project Spectrum website, and any content viewed through our site, is only for your personal and non-commercial use. Any other use requires explicit permission from Resource Provider.</p>

							<b>Training Content and Trademarks</b>
							<p>All training content on this website, including text, images, videos, and other materials, is protected by copyright law. The training content is designed by us and is the intellectual property of Resource Provider and/or its creators. You acknowledge and agree that the Project Spectrum site may contain other content or features that are protected by copyright, patent, trademark or other intellectual property rights and laws. Unless otherwise authorized by Resource Provider, you agree to not change, copy, sell, distribute, or create derivative works based on, the Project Spectrum site or the course content.</p>

							<b>Indemnification</b>
							<p>You agree to indemnify, defend, and hold harmless Resource Provider and its affiliates, directors, employees, cyber advisers, and related parties from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your participation in our course(s).</p>

							<b>No Representations or Warranties</b>
							<p>Resource Provider makes no representations or warranties of any kind, express or implied, regarding the results that may be obtained from participating in Project Spectrum. The course content is provided "as is" and "as available" without any warranties of any kind.</p>

							<b>Limitation of Liability</b>
							<p>To the fullest extent permitted by law, Resource Provider its affiliates, members, directors, employees, cyber advisers, and related parties shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or damages of any other kind or nature, arising out of or related to your participation in Project Spectrum courses, whether based in contract, tort, strict liability, or otherwise, even if Resource Provider has been advised of the possibility of such damages.</p>

							<b>Changes to Disclaimer</b>
							<p>We reserve the right to modify or update this disclaimer at any time. Users should check this page periodically for changes.</p>
						</div>
					`
				}
			},
			currentYear: new Date().getFullYear(),
			socialIcons: [
				{
					id: 1,
					svg: require("@assetsImages/icon-image/linkedin.svg"),
					link: "https://www.linkedin.com/showcase/project-spectrum/",
					altText: "Project Spectrum LinkedIn"
				},
				{
					id: 2,
					svg: require("@assetsImages/icon-image/youtubeicon_.svg"),
					link: "https://www.youtube.com/@project-spectrum",
					altText: "Project Spectrum Youtube"
				}
				// {
				// 	id: 2,
				// 	svg: require("../assets/images/icon-image/facebook.svg"),
				// 	link: "https://www.facebook.com/ProjectSpectrum",
				// },
				// {
				// 	id: 3,
				// 	svg: require("../assets/images/icon-image/instagram.svg"),
				// 	link: "#",
				// },
				// {
				// 	id: 4,
				// 	svg: require("../assets/images/icon-image/Frame 167.svg"),
				// 	link: "https://www.youtube.com/channel/UCHU-4dUkYInJhpabvW6Ps1g",
				// },
			],
			logo: require("@assetsImages/logo/PSFooterLogo.png"),
			privacyDialog: false,
			disclaimerDialog: false,
		// 	disclaimerContent: ` <p>
        //   This website is offered to you, the user ("User"), conditioned on
        //   acceptance of the terms, conditions and notices contained herein,
        //   without modification. &nbsp;User access and use of this site
        //   constitutes acceptance of these terms and conditions.
        // </p>
        // <p>
        //   Project Spectrum is a Web Portal providing access to various
        //   educational and training videos and other tools, as well as an online
        //   community, company dashboard, and Cyber Readiness Check.&nbsp; These
        //   items are provided as resources to assist the User in its effort to
        //   become more cybersecure. &nbsp;The various resources made available at
        //   the Project Spectrum Web Portal are not meant to be used to certify
        //   compliance with any government standard or with that any contractual
        //   obligations a User may have.&nbsp; The resources and data made
        //   available at the Project Spectrum Web Portal are provided "as is"
        //   without warranties of any kind, express or implied, including, but not
        //   limited to, warranties of performance, merchantability and fitness for
        //   a particular purpose. Project Spectrum makes no representations or
        //   warranties regarding the condition or functionality of this website,
        //   its suitability for use, or that this site will be uninterrupted or
        //   error-free.&nbsp; Project Spectrum expressly disclaims any and all
        //   liability arising from use of any of the resources on the Project
        //   Spectrum Web Portal.
        // </p>
        // <p>
        //   The authors and publishers of the information on this site are not
        //   herein engaged in rendering legal or other professional advice or
        //   services. &nbsp;Consequently, such information should not be used as a
        //   substitute for consultation with professional legal or other competent
        //   advisors.
        // </p>
        // <p>
        //   Project Spectrum has made every attempt to ensure that the information
        //   contained in this site is correct.&nbsp; However, Project Spectrum is
        //   not responsible for any errors or omissions, or for the results
        //   obtained from the use of this information.&nbsp; All information on
        //   this site is provided "as is" with no guarantee of completeness,
        //   accuracy, timeliness or of the results obtained from the use of this
        //   information.&nbsp; Additionally, this information is provided without
        //   warranty of any kind, express or implied, including, but not limited
        //   to, warranties of performance, merchantability and fitness for a
        //   particular purpose.&nbsp; In no event will Project Spectrum, its
        //   constituent partners, or the officers, members, agents or employees
        //   thereof be liable to User or anyone else for any decision made or
        //   action taken (or not taken) in reliance on the information in this
        //   site or for any indirect, consequential, special or similar damages,
        //   even if advised of the possibility of such damages.
        // </p>
        // <p>
        //   There are links to third-party Internet websites contained within the
        //   Project Spectrum Web Portal. &nbsp;The websites referenced or linked
        //   from the Project Spectrum Web Portal are not under Project Spectrum
        //   control. Project Spectrum includes these links solely as a convenience
        //   to you, and the presence of such a link is not a referral or an
        //   endorsement of the linked site, its operator, or its contents.
        //   &nbsp;Project Spectrum does not assume any responsibility or liability
        //   for any information, communications or materials available at such
        //   linked sites, or at any link contained in a linked site. &nbsp;User
        //   assumes sole responsibility for use of third-party websites.
        // </p>`,
			privacyContent: `<p>This privacy notice discloses the privacy practices for the
          Project Spectrum website and applies to information collected on the Project
          Spectrum website including, without limitation, registration and login
          information, and information collected by the Project Spectrum internal
          applications. It will notify you of the following:</p>

          <p>1. The personally identifiable information that is collected
          from you through the website, how it is used and with whom it may be shared.</p>

          <p>2. The choices that are available to you regarding the use
          of your data.</p>

          <p>3. The security procedures that are in place to protect the
          misuse of your information.</p>

          <p>4. The method you can employ to correct any inaccuracies in your
          information. </p>

          <p><b>Information Collection </b></p>

          <p>We are the sole owners of the information collected on this
          site. We only collect and have access to information that you voluntarily give
          us by filling out the online forms, via email, or other direct contact from
          you. </p>

          <p><b>Information Use and Disclosure </b></p>

          <p>Information that you voluntarily give us may be used by us,
          or disclosed to third parties, such as a U.S. federal government agency. In
          general, we will deidentify data disclosed to third parties by removing
          information such as your business name and contact details. </p>

          <p><b>Your Access to and Control Over Information </b></p>

          <p>Unless you ask us not to, we may contact you via email or
          phone in the future with updates on the Project Spectrum program, to inform you
          about new products, services, or changes to this privacy policy. </p>

          <p>You may opt out of any future contacts from us at any time.
          You can do so at any time by contacting us via the <a
          href="mailto:support@projectspectrum.io">support@projectspectrum.io</a> email
          address provided on our website to: </p>

          <p>1. Inquire about any personal data we have collected or
          stored. </p>

          <p>2. Change/correct any personal data we have collected or
          stored.</p>

          <p>3. Delete any personal data we have collected or stored. </p>

          <p>4. Express any concern you have about our use of your
          personal data.</p>

          <p><b>Security</b> </p>

          <p><span>We take precautions to protect your
          information. When you submit sensitive information via the website, your
          information is protected in transit, in use, and at rest (stored).</span></p>

          <p><span>Wherever information is collected through the
          Project Spectrum website, such information is encrypted and transmitted using
          the latest cryptographic algorithms for data transport. </span></p>

          <p><span>While we use encryption to protect sensitive
          information transmitted online, we also protect it while it is being used and
          at rest (i.e. being stored). </span></p>

          <p><span>Only employees who need the information to
          perform a specific job are granted access to any personally identifiable
          information. The computers/servers in which we store personally identifiable
          information are kept in a secure environment. </span></p>

          <p><span>We reserve
          the right to revise this Privacy Policy at any time and for any reason. Any
          revisions will be effective immediately upon posting the revised Privacy Policy
          on the Project Spectrum website and you hereby waive any right to receive
          specific notice of any such revision.</span></p>`,
		};
	},
	computed: {
		disclaimerTitleText() {
			return this.navControlTitleSelection[this.selectedDisclaimerNavItem].title;
		},
		disclaimerTitleButtons() {
			return this.navControlTitleSelection[this.selectedDisclaimerNavItem].buttons;
		},
		disclaimerText() {
			const __disclaimerTitle = this.navControlTitleSelection[this.selectedDisclaimerNavItem].selectedTextContent;
			return __disclaimerTitle 
					? this.navControlTitleSelection[this.selectedDisclaimerNavItem].buttons.find(({ title }) => title === __disclaimerTitle).text
					: this.navControlTitleSelection[this.selectedDisclaimerNavItem].text;
		},
		isMobileView() {
			return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
		}
	},
	methods: {
		setActiveDisclaimerButtonText(buttonTextTitle) {
			this.navControlTitleSelection[this.selectedDisclaimerNavItem].selectedTextContent = buttonTextTitle;
			this.isDisclaimerMobileMenuOpened = false;
			this.hasDisclaimerButtons = false;
		},
		disclaimerNavigationClickHandler(disclaimerTitle) {
			this.selectedDisclaimerNavItem = disclaimerTitle;
			if(disclaimerTitle === 'Training Content') {
				this.hasDisclaimerButtons = this.navControlTitleSelection[this.selectedDisclaimerNavItem].buttons.length;
			}
			this.isDisclaimerMobileMenuOpened = false;
		},
		showDisclaimerNavigationMenu() {
			this.isDisclaimerMobileMenuOpened = !this.isDisclaimerMobileMenuOpened;
			this.hasDisclaimerButtons = false;
		},
	},
	watch: {
		showFooterOverlay(newValue) {
			if(!newValue) {
				this.selectedDisclaimerNavItem = this.disclaimerSubjects.GENERAL;
			}
		}
	}
};
</script>

<style scoped>
.text-follow-us {
	font-size: clamp(14px, 1vw, 1rem);
	font-family: "Open Sans", sans-serif;
	font-weight: 700;
	line-height: normal;
	font-style: normal;
}
.text-copyright {
	font-size: clamp(8px, 1vw, 14px);
	font-family: "Open Sans", sans-serif;
	color: #e6e6e6;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
}

.text-underline-links {
	font-size: clamp(12px, 1vw, 14px);
	padding-inline: 5px !important;
	font-family: "Open Sans", sans-serif;
	font-weight: 700;
	color: #e6e6e6;
}

.text-description {
	font-size: clamp(10px, 1vw, 12px);
	font-family: "Open Sans", sans-serif;
	color: #e6e6e6;
	text-align: left;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	padding-right: 10%;
}

.text-question {
	font-size: clamp(14px, 1vw, 16px);
	font-family: "Open Sans", sans-serif;
	color: #e6e6e6;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
}

:deep .btn-primary {
	color: #fff;
	background-color: rgb(66, 78, 196) !important;
	border-color: rgb(66, 78, 196) !important;
}

.custom-modal-footer .btn-primary {
	background-color: rgb(66, 78, 196) !important;
	border-color: rgb(66, 78, 196) !important;
}

.disclaimer-navbar {
	width: 100%;
	height: 10%;
	background-color: #424EC4;
	border: 1px solid #424EC4;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	position: relative;
}

.disclaimer-navbar-content {
	position: absolute;
	height: 100%;
}

.disclaimer-navbar-row {
	height: 100%;
	margin-top: 0px;
}

.disclaimer-navbar-text {
	text-align: center;
	font-family: Rajdhani;
	font-size: 17.469px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
}
.disclaimer-navbar-text:hover {
	cursor: pointer;
}

.disclamer-body-content {
	height: 100%;
	margin-top: 0;
}

.disclaimer-title-section {
	width: 100%;
	height: 20%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding-top: 25px;
}

.disclaimer-button-section {
	width: 100%;
	height: 80%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
}

.navbar-toggler i {
	font-size: 28px;
	color: #fff;
}
.project-spectrum-image {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
	padding: 0;
}

</style>
